module.exports = __webpack_public_path__ + "img/2024-06.3357edd9.jpg";